module.exports = {
    VERSION: '1.7.1', //版本号
    // VERSION: '6.6.6', //版本号
    GLOBAL_API_ROOT: 'https://ceping.medkg.cn/', // 后端请求地址
    VERSION_ROOT: 'https://software.medkg.cn/', // 版本请求地址
    // const KNOWLEDGE_API_ROOT = 'https://annotator-test.i-tcm.cn/'; // 后端请求地址
    KNOWLEDGE_API_ROOT: 'https://annotator-validate.i-tcm.cn/', // 后端请求地址
    GLOBAL_SYSTEM: '医生端', // 医生端或管理端
    ID: "", // 用来获取项目信息，如果不需要通过请求获取，则此字段不要填，填下面SYSTEM_MSG字段
    SYSTEM_MSG: {
        name: '中医诊测采集分析系统', // 项目名称
        logo: '/common/cep.png',
        favicon_url: '/common/cep.ico'
    },
    SETTING: { // 项目特殊配置
        ifDesktop: true, // 是否是桌面端
        ifVerifyLight: true,
        ifVerify: true,
        ifRememberPassword: true, //是否显示记住密码
        ifFingerprint: false, // 是否指纹登录
        ifAutoUpdate: false, //是否自动更新
        showLanguage: false, // 是否显示语言切换
        defaultLanguage: 'Chinese', // Chinese or English
        model: ['健康测评'], // 四诊、健康测评、健康设备。可根据项目情况配置一个或者多个以及顺序
        teacherNav: ["新建档案", "体质诊测", "系统设置"],
    },
    PART: {
        四诊: {
            name: '四诊客观化数据', // 前端页面显示文字，可根据项目情况进行修改
            value: '四诊客观化数据', // 前后端交互需要用到的，跟CRF那边保持一致，不可随意修改
            tip: '通过四诊客观化设备采集舌象、面象、脉象、舌底数据。', // 提示文字
        },
        健康测评: {
            name: '健康测评数据',
            value: '健康测评数据',
            tip: '由医生采集客户量表数据进行健康评估。'
        },
        健康设备: {
            name: '健康设备数据',
            value: '健康设备数据',
            tip: '通过健康设备采集客户体检数据进行健康评估。'
        }
    },
    THEME: {
        login: '教学', // 测评 or 教学
        // defaultSize: '大', // 默认字号
        // ifCanChangeSize: true, // 是否允许在头部切换字号
        // 文字大小配置,
        bigSize: '32px',
        h1Size: '24px',
        h2Size: '22px',
        h3Size: '20px',
        mainSize: '18px',
        miniSize: '16px',
        templateSize: '20px',
        // 颜色配置
        // 测评
        // primaryColor: '#C97424', // 主题色
        // subPrimaryColor: '#9C661A', // 副主题色
        // miniPrimaryColor: '#FCF3EA', // 浅主题色
        // tableBorderColor: '#F4ECE1', // 表格头部底色
        // scrollbarColor: 'rgba(201, 116, 36, 0.4)', //滚动条颜色
        // pageBg: "url('/common/page-bg.png')", //页面背景底图

        // 教学
        primaryColor: '#733F2E', // 主题色
        subPrimaryColor: '#1B5AB2', // 副主题色
        miniPrimaryColor: 'rgba(110, 64, 0, 0.1)', // 浅主题色
        tableBorderColor: 'rgba(110, 64, 0, 0.1)', // 表格头部底色
        tableHoverColor: 'rgba(110, 64, 0, 0.2)', // 表格头部底色
        scrollbarColor: 'rgba(115, 63, 46, 0.4)', //滚动条颜色
        pageBg: "url('/common/page-bg2.png')", //页面背景底图

        // 白色底的四周阴影配置
        boxShadow: '0 2 px 12 px 0 rgba(0, 0, 0, 0.15)', // 四周阴影
    },

    SYSTEM_NAV: {
        // 医生端的头部导航
        topNav: {
            新建档案: {
                name: '新建档案',
                path: '/main/patient/folder',
                activePath: '/main/patient'
            },
            体质诊测: {
                name: '体质诊测',
                path: '/main/manage/folder',
                activePath: '/main/manage'
            },
            诊测统计: {
                name: '诊测统计',
                path: '/main/assess/folder',
                activePath: '/main/assess'
            },
            数据统计: {
                name: '数据统计',
                path: '/main/statistics/folder',
                activePath: '/main/statistics'
            },
            知识库: {
                name: '知识库',
                path: '/main/knowledge/folder',
                activePath: '/main/knowledge'
            },
            系统设置: {
                name: '系统设置',
                activePath: 'main/system',
                children: [{
                    parent: '系统设置',
                    name: '来源管理',
                    path: '/main/system/channel-list',
                    activePath: '/main/system/channel'
                }, ]
            },
        },
        // 管理端的左侧导航
        leftNav: [{
                name: '测评管理',
                icon: '测评',
                path: '/main/evaluation/list',
                activePath: '/main/evaluation'
            },
            {
                name: '账户管理',
                icon: '账户',
                activePath: '/main/account',
                open: true,
                children: [{
                        parent: '账户管理',
                        name: '账户信息',
                        path: '/main/account/zhanghu-list',
                        activePath: '/main/account/zhanghu'
                    },
                    {
                        parent: '账户管理',
                        name: '角色管理',
                        path: '/main/account/juese-list',
                        activePath: '/main/account/juese'
                    },
                    {
                        parent: '账户管理',
                        name: '组织架构',
                        path: '/main/account/zuzhi-list',
                        activePath: '/main/account/zuzhi'
                    },
                ]
            },
            {
                name: '系统设置',
                icon: '系统',
                activePath: '/main/system',
                open: true,
                children: [{
                    parent: '系统设置',
                    name: '软件管理',
                    path: '/main/system/software-folder',
                    activePath: '/main/system/software'
                }, ]
            },
        ],
    },

    // 以下是打包桌面端需要用到的
    // electron-builder.yml
    ProductName: 'zycp', // exe名称
    APP_ID: 'com.ceping.www', // 应用的唯一id,确认后不要改动了！不然在更新时候，会被认做为两个应用。这个是在apple那里你申请证书的时候，用生成的那个id就可以，类似这种'com.example.app'
    COPYRIGHT: 'ceping', // 版权信息
    // 以下图标从请求获取
    LOGO: './public/common/cep.ico', // logo路径,格式为.ico，大小需要256*256的，否则打包会报错

    // package.json
    PACKAGE_NAME: 'ceping' //包名
}